// assets/search-aliases.js

(function() {
  function normalize(str) {
    return str.toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  const SEARCH_INDEX = [
  // ── A ──
  {
    canonical: "Afghanistan",
    priority: 1,
    terms: ["afghanistan", "af", "afghanestan"]
  },
  {
    canonical: "Albania",
    priority: 1,
    terms: ["albania", "albanien", "albanie", "albania", "al", "shqiperi"]
  },
  {
    canonical: "Algeria",
    priority: 1,
    terms: ["algeria", "algerien", "algerie", "argelia", "dz"]
  },
  {
    canonical: "Andorra",
    priority: 1,
    terms: ["andorra", "ad"]
  },
  {
    canonical: "Anguilla",
    priority: 1,
    terms: ["anguilla", "ai"]
  },
  {
    canonical: "Armenia",
    priority: 1,
    terms: ["armenia", "armenien", "armenie", "am"]
  },
  {
    canonical: "Aruba",
    priority: 1,
    terms: ["aruba", "aw"]
  },
  {
    canonical: "Australia",
    priority: 1,
    terms: ["australia", "australien", "australie", "aus", "au"]
  },
  {
    canonical: "Austria",
    priority: 1,
    terms: ["austria", "osterreich", "österreich", "autriche", "austria", "at"]
  },
  {
    canonical: "Azerbaijan",
    priority: 1,
    terms: ["azerbaijan", "aserbaidschan", "azerbaidjan", "azerbaiyan", "az"]
  },

  // ── B ──
  {
    canonical: "Bahamas",
    priority: 1,
    terms: ["bahamas", "bs"]
  },
  {
    canonical: "Bahrain",
    priority: 1,
    terms: ["bahrain", "bahrein", "bh"]
  },
  {
    canonical: "Bangladesh",
    priority: 1,
    terms: ["bangladesh", "bangladesch", "bd"]
  },
  {
    canonical: "Barbados",
    priority: 1,
    terms: ["barbados", "bb"]
  },
  {
    canonical: "Belarus",
    priority: 1,
    terms: ["belarus", "weissrussland", "weißrussland", "bielorussie", "bielorrusia", "by"]
  },
  {
    canonical: "Belgium",
    priority: 1,
    terms: ["belgium", "belgien", "belgique", "belgica", "be"]
  },
  {
    canonical: "Belize",
    priority: 1,
    terms: ["belize", "bz"]
  },
  {
    canonical: "Benin",
    priority: 1,
    terms: ["benin", "bj"]
  },
  {
    canonical: "Bermuda",
    priority: 1,
    terms: ["bermuda", "bm"]
  },
  {
    canonical: "Bhutan",
    priority: 1,
    terms: ["bhutan", "bt"]
  },
  {
    canonical: "Bolivia",
    priority: 1,
    terms: ["bolivia", "bolivien", "bolivie", "bo"]
  },
  {
    canonical: "Bosnia and Herzegovina",
    priority: 1,
    terms: ["bosnia", "bosnien", "bosnia and herzegovina", "bosnie", "bosnia herzegowina", "ba"]
  },
  {
    canonical: "Botswana",
    priority: 1,
    terms: ["botswana", "bw"]
  },
  {
    canonical: "Brazil",
    priority: 1,
    terms: ["brazil", "brasilien", "bresil", "brasil", "br"]
  },
  {
    canonical: "British Virgin Islands",
    priority: 1,
    terms: ["british virgin islands", "britische jungferninseln", "vg", "bvi"]
  },
  {
    canonical: "Brunei",
    priority: 1,
    terms: ["brunei", "bn"]
  },
  {
    canonical: "Bulgaria",
    priority: 1,
    terms: ["bulgaria", "bulgarien", "bulgarie", "bulgaria", "bg"]
  },
  {
    canonical: "Burkina Faso",
    priority: 1,
    terms: ["burkina faso", "bf"]
  },

  // ── C ──
  {
    canonical: "Cambodia",
    priority: 1,
    terms: ["cambodia", "kambodscha", "cambodge", "camboya", "kh", "khmer"]
  },
  {
    canonical: "Cameroon",
    priority: 1,
    terms: ["cameroon", "kamerun", "cameroun", "cm"]
  },
  {
    canonical: "Canada",
    priority: 1,
    terms: ["canada", "kanada", "ca"]
  },
  {
    canonical: "Cape Verde",
    priority: 1,
    terms: ["cape verde", "kap verde", "cap vert", "cabo verde", "cv"]
  },
  {
    canonical: "Cayman Islands",
    priority: 1,
    terms: ["cayman islands", "kaimaninseln", "iles caimans", "ky", "cayman"]
  },
  {
    canonical: "Central African Republic",
    priority: 1,
    terms: ["central african republic", "zentralafrikanische republik", "republique centrafricaine", "cf", "car"]
  },
  {
    canonical: "Chad",
    priority: 1,
    terms: ["chad", "tschad", "tchad", "td"]
  },
  {
    canonical: "Chile",
    priority: 1,
    terms: ["chile", "cl"]
  },
  {
    canonical: "China",
    priority: 1,
    terms: ["china", "cn", "zhongguo", "prc", "volksrepublik china"]
  },
  {
    canonical: "Colombia",
    priority: 1,
    terms: ["colombia", "kolumbien", "colombie", "co"]
  },
  {
    canonical: "Costa Rica",
    priority: 1,
    terms: ["costa rica", "cr"]
  },
  {
    canonical: "Croatia",
    priority: 1,
    terms: ["croatia", "kroatien", "croatie", "croacia", "hr", "hrvatska"]
  },
  {
    canonical: "Curacao",
    priority: 1,
    terms: ["curacao", "curaçao", "cw"]
  },
  {
    canonical: "Cyprus",
    priority: 1,
    terms: ["cyprus", "zypern", "chypre", "chipre", "cy"]
  },
  {
    canonical: "Czech Republic",
    priority: 1,
    terms: ["czech republic", "tschechien", "tschechische republik", "republique tcheque", "republica checa", "cz", "czechia", "czech"]
  },

  // ── D ──
  {
    canonical: "Denmark",
    priority: 1,
    terms: ["denmark", "danemark", "dinamarca", "dk", "danmark"]
  },
  {
    canonical: "Dominica",
    priority: 1,
    terms: ["dominica", "dm"]
  },
  {
    canonical: "Dominican Republic",
    priority: 1,
    terms: ["dominican republic", "dominikanische republik", "republique dominicaine", "republica dominicana", "do"]
  },

  // ── E ──
  {
    canonical: "Ecuador",
    priority: 1,
    terms: ["ecuador", "ec"]
  },
  {
    canonical: "Egypt",
    priority: 1,
    terms: ["egypt", "agypten", "ägypten", "egypte", "egipto", "eg"]
  },
  {
    canonical: "El Salvador",
    priority: 1,
    terms: ["el salvador", "sv"]
  },
  {
    canonical: "Estonia",
    priority: 1,
    terms: ["estonia", "estland", "estonie", "ee", "eesti"]
  },
  {
    canonical: "Ethiopia",
    priority: 1,
    terms: ["ethiopia", "athiopien", "äthiopien", "ethiopie", "et"]
  },

  // ── F ──
  {
    canonical: "Faroe Islands",
    priority: 1,
    terms: ["faroe islands", "faroer", "färöer", "iles feroe", "fo"]
  },
  {
    canonical: "Fiji",
    priority: 1,
    terms: ["fiji", "fj"]
  },
  {
    canonical: "Finland",
    priority: 1,
    terms: ["finland", "finnland", "finlande", "finlandia", "fi", "suomi"]
  },
  {
    canonical: "France",
    priority: 1,
    terms: ["france", "frankreich", "francia", "fr"]
  },

  // ── G ──
  {
    canonical: "Gabon",
    priority: 1,
    terms: ["gabon", "gabun", "ga"]
  },
  {
    canonical: "Gambia",
    priority: 1,
    terms: ["gambia", "gm"]
  },
  {
    canonical: "Georgia",
    priority: 1,
    terms: ["georgia", "georgien", "georgie", "ge"]
  },
  {
    canonical: "Germany",
    priority: 1,
    terms: ["germany", "deutschland", "allemagne", "alemania", "de"]
  },
  {
    canonical: "Ghana",
    priority: 1,
    terms: ["ghana", "gh"]
  },
  {
    canonical: "Gibraltar",
    priority: 1,
    terms: ["gibraltar", "gi"]
  },
  {
    canonical: "Greece",
    priority: 1,
    terms: ["greece", "griechenland", "grece", "grecia", "gr", "hellas"]
  },
  {
    canonical: "Greenland",
    priority: 1,
    terms: ["greenland", "gronland", "grönland", "groenland", "gl"]
  },
  {
    canonical: "Grenada",
    priority: 1,
    terms: ["grenada", "gd"]
  },
  {
    canonical: "Guadeloupe",
    priority: 1,
    terms: ["guadeloupe", "gp"]
  },
  {
    canonical: "Guatemala",
    priority: 1,
    terms: ["guatemala", "gt"]
  },
  {
    canonical: "Guinea",
    priority: 1,
    terms: ["guinea", "guinee", "gn"]
  },
  {
    canonical: "Guinea-Bissau",
    priority: 1,
    terms: ["guinea-bissau", "guinea bissau", "gw"]
  },
  {
    canonical: "Guyana",
    priority: 1,
    terms: ["guyana", "gy"]
  },

  // ── H ──
  {
    canonical: "Haiti",
    priority: 1,
    terms: ["haiti", "ht"]
  },
  {
    canonical: "Honduras",
    priority: 1,
    terms: ["honduras", "hn"]
  },
  {
    canonical: "Hong Kong",
    priority: 1,
    terms: ["hong kong", "hongkong", "hk"]
  },
  {
    canonical: "Hungary",
    priority: 1,
    terms: ["hungary", "ungarn", "hongrie", "hungria", "hu", "magyarorszag"]
  },

  // ── I ──
  {
    canonical: "Iceland",
    priority: 1,
    terms: ["iceland", "island", "islande", "islandia", "is"]
  },
  {
    canonical: "India",
    priority: 1,
    terms: ["india", "indien", "inde", "in"]
  },
  {
    canonical: "Indonesia",
    priority: 1,
    terms: ["indonesia", "indonesien", "indonesie", "id"]
  },
  {
    canonical: "Iraq",
    priority: 1,
    terms: ["iraq", "irak", "iq"]
  },
  {
    canonical: "Ireland",
    priority: 1,
    terms: ["ireland", "irland", "irlande", "irlanda", "ie", "eire"]
  },
  {
    canonical: "Isle of Man",
    priority: 1,
    terms: ["isle of man", "im"]
  },
  {
    canonical: "Israel",
    priority: 1,
    terms: ["israel", "il"]
  },
  {
    canonical: "Italy",
    priority: 1,
    terms: ["italy", "italien", "italie", "italia", "it"]
  },

  // ── J ──
  {
    canonical: "Jamaica",
    priority: 1,
    terms: ["jamaica", "jamaika", "jm"]
  },
  {
    canonical: "Japan",
    priority: 1,
    terms: ["japan", "jp", "nippon"]
  },
  {
    canonical: "Jersey",
    priority: 1,
    terms: ["jersey", "je"]
  },
  {
    canonical: "Jordan",
    priority: 1,
    terms: ["jordan", "jordanien", "jordanie", "jordania", "jo"]
  },

  // ── K ──
  {
    canonical: "Kazakhstan",
    priority: 1,
    terms: ["kazakhstan", "kasachstan", "kazakhstan", "kazajistan", "kz"]
  },
  {
    canonical: "Kenya",
    priority: 1,
    terms: ["kenya", "kenia", "ke"]
  },
  {
    canonical: "Kosovo",
    priority: 1,
    terms: ["kosovo", "xk"]
  },
  {
    canonical: "Kuwait",
    priority: 1,
    terms: ["kuwait", "kw"]
  },
  {
    canonical: "Kyrgyzstan",
    priority: 1,
    terms: ["kyrgyzstan", "kirgisistan", "kirghizistan", "kg", "kyrgyz"]
  },

  // ── L ──
  {
    canonical: "Laos",
    priority: 1,
    terms: ["laos", "la"]
  },
  {
    canonical: "Latvia",
    priority: 1,
    terms: ["latvia", "lettland", "lettonie", "letonia", "lv", "latvija"]
  },
  {
    canonical: "Lebanon",
    priority: 1,
    terms: ["lebanon", "libanon", "liban", "libano", "lb"]
  },
  {
    canonical: "Lesotho",
    priority: 1,
    terms: ["lesotho", "ls"]
  },
  {
    canonical: "Liberia",
    priority: 1,
    terms: ["liberia", "lr"]
  },
  {
    canonical: "Liechtenstein",
    priority: 1,
    terms: ["liechtenstein", "li"]
  },
  {
    canonical: "Lithuania",
    priority: 1,
    terms: ["lithuania", "litauen", "lituanie", "lituania", "lt", "lietuva"]
  },
  {
    canonical: "Luxembourg",
    priority: 1,
    terms: ["luxembourg", "luxemburg", "lu"]
  },

  // ── M ──
  {
    canonical: "Macau",
    priority: 1,
    terms: ["macau", "macao", "mo"]
  },
  {
    canonical: "Macedonia",
    priority: 1,
    terms: ["macedonia", "mazedonien", "macedoine", "mk", "north macedonia", "nordmazedonien"]
  },
  {
    canonical: "Madagascar",
    priority: 1,
    terms: ["madagascar", "madagaskar", "mg"]
  },
  {
    canonical: "Malawi",
    priority: 1,
    terms: ["malawi", "mw"]
  },
  {
    canonical: "Malaysia",
    priority: 1,
    terms: ["malaysia", "malaysien", "malaisie", "my"]
  },
  {
    canonical: "Maldives",
    priority: 1,
    terms: ["maldives", "malediven", "maldives", "mv"]
  },
  {
    canonical: "Mali",
    priority: 1,
    terms: ["mali", "ml"]
  },
  {
    canonical: "Malta",
    priority: 1,
    terms: ["malta", "mt"]
  },
  {
    canonical: "Martinique",
    priority: 1,
    terms: ["martinique", "mq"]
  },
  {
    canonical: "Mauritius",
    priority: 1,
    terms: ["mauritius", "mu"]
  },
  {
    canonical: "Mayotte",
    priority: 1,
    terms: ["mayotte", "yt"]
  },
  {
    canonical: "Mexico",
    priority: 1,
    terms: ["mexico", "mexiko", "mexique", "mx"]
  },
  {
    canonical: "Moldova",
    priority: 1,
    terms: ["moldova", "moldawien", "moldavie", "md"]
  },
  {
    canonical: "Mongolia",
    priority: 1,
    terms: ["mongolia", "mongolei", "mongolie", "mn"]
  },
  {
    canonical: "Montenegro",
    priority: 1,
    terms: ["montenegro", "me"]
  },
  {
    canonical: "Montserrat",
    priority: 1,
    terms: ["montserrat", "ms"]
  },
  {
    canonical: "Morocco",
    priority: 1,
    terms: ["morocco", "marokko", "maroc", "marruecos", "ma"]
  },
  {
    canonical: "Mozambique",
    priority: 1,
    terms: ["mozambique", "mosambik", "mz"]
  },

  // ── N ──
  {
    canonical: "Nauru",
    priority: 1,
    terms: ["nauru", "nr"]
  },
  {
    canonical: "Nepal",
    priority: 1,
    terms: ["nepal", "np"]
  },
  {
    canonical: "Netherlands",
    priority: 1,
    terms: ["netherlands", "niederlande", "pays-bas", "paises bajos", "nl", "holland"]
  },
  {
    canonical: "New Zealand",
    priority: 1,
    terms: ["new zealand", "neuseeland", "nouvelle-zelande", "nueva zelanda", "nz"]
  },
  {
    canonical: "Nicaragua",
    priority: 1,
    terms: ["nicaragua", "ni"]
  },
  {
    canonical: "Niger",
    priority: 1,
    terms: ["niger", "ne"]
  },
  {
    canonical: "Nigeria",
    priority: 1,
    terms: ["nigeria", "ng"]
  },
  {
    canonical: "Norway",
    priority: 1,
    terms: ["norway", "norwegen", "norvege", "noruega", "no", "norge"]
  },

  // ── O ──
  {
    canonical: "Oman",
    priority: 1,
    terms: ["oman", "om"]
  },

  // ── P ──
  {
    canonical: "Pakistan",
    priority: 1,
    terms: ["pakistan", "pk"]
  },
  {
    canonical: "Palestine",
    priority: 1,
    terms: ["palestine", "palastina", "palästina", "palestina", "ps"]
  },
  {
    canonical: "Panama",
    priority: 1,
    terms: ["panama", "pa"]
  },
  {
    canonical: "Papua New Guinea",
    priority: 1,
    terms: ["papua new guinea", "papua-neuguinea", "papouasie", "pg", "png"]
  },
  {
    canonical: "Paraguay",
    priority: 1,
    terms: ["paraguay", "py"]
  },
  {
    canonical: "Peru",
    priority: 1,
    terms: ["peru", "pe"]
  },
  {
    canonical: "Philippines",
    priority: 1,
    terms: ["philippines", "philippinen", "filipinas", "ph"]
  },
  {
    canonical: "Poland",
    priority: 1,
    terms: ["poland", "polen", "pologne", "polonia", "pl", "polska"]
  },
  {
    canonical: "Portugal",
    priority: 1,
    terms: ["portugal", "pt"]
  },
  {
    canonical: "Puerto Rico",
    priority: 1,
    terms: ["puerto rico", "pr"]
  },

  // ── Q ──
  {
    canonical: "Qatar",
    priority: 1,
    terms: ["qatar", "katar", "qa"]
  },

  // ── R ──
  {
    canonical: "Republic of the Congo",
    priority: 1,
    terms: ["republic of the congo", "kongo", "congo", "republique du congo", "cg"]
  },
  {
    canonical: "Reunion",
    priority: 1,
    terms: ["reunion", "réunion", "re"]
  },
  {
    canonical: "Romania",
    priority: 1,
    terms: ["romania", "rumanien", "rumänien", "roumanie", "rumania", "ro"]
  },
  {
    canonical: "Rwanda",
    priority: 1,
    terms: ["rwanda", "ruanda", "rw"]
  },

  // ── S ──
  {
    canonical: "Saint Barthelemy",
    priority: 1,
    terms: ["saint barthelemy", "saint-barthelemy", "st barts", "bl"]
  },
  {
    canonical: "Saint Kitts and Nevis",
    priority: 1,
    terms: ["saint kitts and nevis", "st kitts", "kn"]
  },
  {
    canonical: "Saint Lucia",
    priority: 1,
    terms: ["saint lucia", "st lucia", "lc"]
  },
  {
    canonical: "Saint Vincent and the Grenadines",
    priority: 1,
    terms: ["saint vincent and the grenadines", "st vincent", "vc"]
  },
  {
    canonical: "Samoa",
    priority: 1,
    terms: ["samoa", "ws"]
  },
  {
    canonical: "Saudi Arabia",
    priority: 1,
    terms: ["saudi arabia", "saudi-arabien", "arabie saoudite", "arabia saudi", "sa", "ksa"]
  },
  {
    canonical: "Senegal",
    priority: 1,
    terms: ["senegal", "sn"]
  },
  {
    canonical: "Serbia",
    priority: 1,
    terms: ["serbia", "serbien", "serbie", "rs"]
  },
  {
    canonical: "Seychelles",
    priority: 1,
    terms: ["seychelles", "seychellen", "sc"]
  },
  {
    canonical: "Sierra Leone",
    priority: 1,
    terms: ["sierra leone", "sl"]
  },
  {
    canonical: "Singapore",
    priority: 1,
    terms: ["singapore", "singapur", "singapour", "sg"]
  },
  {
    canonical: "Slovakia",
    priority: 1,
    terms: ["slovakia", "slowakei", "slovaquie", "eslovaquia", "sk", "slovensko"]
  },
  {
    canonical: "Slovenia",
    priority: 1,
    terms: ["slovenia", "slowenien", "slovenie", "eslovenia", "si", "slovenija"]
  },
  {
    canonical: "South Africa",
    priority: 1,
    terms: ["south africa", "sudafrika", "südafrika", "afrique du sud", "sudafrica", "za", "rsa"]
  },
  {
    canonical: "South Korea",
    priority: 1,
    terms: ["south korea", "sudkorea", "südkorea", "coree du sud", "corea del sur", "kr", "korea"]
  },
  {
    canonical: "Spain",
    priority: 1,
    terms: ["spain", "spanien", "espagne", "espana", "españa", "es"]
  },
  {
    canonical: "Sri Lanka",
    priority: 1,
    terms: ["sri lanka", "lk", "ceylon"]
  },
  {
    canonical: "Suriname",
    priority: 1,
    terms: ["suriname", "sr"]
  },
  {
    canonical: "Sweden",
    priority: 1,
    terms: ["sweden", "schweden", "suede", "suecia", "se", "sverige"]
  },
  {
    canonical: "Switzerland",
    priority: 1,
    terms: ["switzerland", "schweiz", "suisse", "suiza", "ch"]
  },

  // ── T ──
  {
    canonical: "Taiwan",
    priority: 1,
    terms: ["taiwan", "tw"]
  },
  {
    canonical: "Tajikistan",
    priority: 1,
    terms: ["tajikistan", "tadschikistan", "tadjikistan", "tj"]
  },
  {
    canonical: "Tanzania",
    priority: 1,
    terms: ["tanzania", "tansania", "tanzanie", "tz"]
  },
  {
    canonical: "Thailand",
    priority: 1,
    terms: ["thailand", "th"]
  },
  {
    canonical: "Togo",
    priority: 1,
    terms: ["togo", "tg"]
  },
  {
    canonical: "Tonga",
    priority: 1,
    terms: ["tonga", "to"]
  },
  {
    canonical: "Trinidad and Tobago",
    priority: 1,
    terms: ["trinidad and tobago", "trinidad", "tobago", "tt"]
  },
  {
    canonical: "Tunisia",
    priority: 1,
    terms: ["tunisia", "tunesien", "tunisie", "tunez", "tn"]
  },
  {
    canonical: "Turkey",
    priority: 1,
    terms: ["turkey", "turkei", "türkei", "turquie", "turquia", "tr", "turkiye"]
  },
  {
    canonical: "Turks and Caicos Islands",
    priority: 1,
    terms: ["turks and caicos", "turks and caicos islands", "tc"]
  },

  // ── U ──
  {
    canonical: "U.S. Virgin Islands",
    priority: 1,
    terms: ["us virgin islands", "u.s. virgin islands", "usvi", "vi"]
  },
  {
    canonical: "Uganda",
    priority: 1,
    terms: ["uganda", "ug"]
  },
  {
    canonical: "Ukraine",
    priority: 1,
    terms: ["ukraine", "ua"]
  },
  {
    canonical: "United Arab Emirates",
    priority: 1,
    terms: ["united arab emirates", "uae", "vereinigte arabische emirate", "emirats arabes unis", "emiratos arabes", "ae", "dubai", "abu dhabi"]
  },
  {
    canonical: "United Kingdom",
    priority: 1,
    terms: ["united kingdom", "uk", "grossbritannien", "großbritannien", "grande-bretagne", "gran bretana", "gb", "england", "britain"]
  },
  {
    canonical: "United States",
    priority: 1,
    terms: ["united states", "usa", "us", "vereinigte staaten", "etats-unis", "estados unidos", "america"]
  },
  {
    canonical: "Uruguay",
    priority: 1,
    terms: ["uruguay", "uy"]
  },
  {
    canonical: "Uzbekistan",
    priority: 1,
    terms: ["uzbekistan", "usbekistan", "ouzbekistan", "uz"]
  },

  // ── V ──
  {
    canonical: "Vanuatu",
    priority: 1,
    terms: ["vanuatu", "vu"]
  },
  {
    canonical: "Vatican City",
    priority: 1,
    terms: ["vatican", "vatican city", "vatikan", "vatikanstadt", "va"]
  },
  {
    canonical: "Venezuela",
    priority: 1,
    terms: ["venezuela", "ve"]
  },
  {
    canonical: "Vietnam",
    priority: 1,
    terms: ["vietnam", "viet nam", "vn"]
  },

  // ── Z ──
  {
    canonical: "Zambia",
    priority: 1,
    terms: ["zambia", "sambia", "zm"]
  },

  // ─────────────────────────────────────────
  // CITIES (priority 2)
  // ─────────────────────────────────────────
  {
    canonical: "Germany",
    priority: 2,
    terms: ["berlin", "munich", "munchen", "münchen", "frankfurt", "hamburg", "cologne", "koln", "köln", "dusseldorf", "düsseldorf", "stuttgart", "leipzig"]
  },
  {
    canonical: "France",
    priority: 2,
    terms: ["paris", "lyon", "marseille", "nice", "bordeaux", "toulouse", "strasbourg"]
  },
  {
    canonical: "United Kingdom",
    priority: 2,
    terms: ["london", "manchester", "edinburgh", "glasgow", "birmingham", "liverpool"]
  },
  {
    canonical: "United States",
    priority: 2,
    terms: ["new york", "ny", "los angeles", "chicago", "miami", "houston", "las vegas", "san francisco","sf", "boston", "seattle", "washington"]
  },
  {
    canonical: "Italy",
    priority: 2,
    terms: ["rome", "roma", "milan", "milano", "venice", "venezia", "florence", "firenze", "naples", "napoli"]
  },
  {
    canonical: "Spain",
    priority: 2,
    terms: ["madrid", "barcelona", "seville", "sevilla", "valencia", "malaga", "ibiza"]
  },
  {
    canonical: "Japan",
    priority: 2,
    terms: ["tokyo", "osaka", "kyoto", "hiroshima", "sapporo", "fukuoka"]
  },
  {
    canonical: "Australia",
    priority: 2,
    terms: ["sydney", "melbourne", "brisbane", "perth", "adelaide"]
  },
  {
    canonical: "Canada",
    priority: 2,
    terms: ["toronto", "vancouver", "montreal", "calgary", "ottawa"]
  },
  {
    canonical: "China",
    priority: 2,
    terms: ["beijing", "shanghai", "shenzhen", "guangzhou", "chengdu", "peking"]
  },
  {
    canonical: "United Arab Emirates",
    priority: 2,
    terms: ["dubai", "abu dhabi", "sharjah"]
  },
  {
    canonical: "Thailand",
    priority: 2,
    terms: ["bangkok", "phuket", "chiang mai", "pattaya", "krabi"]
  },
  {
    canonical: "Turkey",
    priority: 2,
    terms: ["istanbul", "ankara", "antalya", "izmir", "cappadocia", "bodrum"]
  },
  {
    canonical: "India",
    priority: 2,
    terms: ["mumbai", "delhi", "bangalore", "kolkata", "chennai", "hyderabad", "goa", "bombay"]
  },
  {
    canonical: "Brazil",
    priority: 2,
    terms: ["sao paulo", "rio de janeiro", "rio", "brasilia", "salvador"]
  },
  {
    canonical: "Mexico",
    priority: 2,
    terms: ["mexico city", "cancun", "guadalajara", "monterrey"]
  },
  {
    canonical: "Netherlands",
    priority: 2,
    terms: ["amsterdam", "rotterdam", "the hague", "den haag", "utrecht"]
  },
  {
    canonical: "Portugal",
    priority: 2,
    terms: ["lisbon", "lissabon", "porto", "lisboa", "faro", "algarve"]
  },
  {
    canonical: "Greece",
    priority: 2,
    terms: ["athens", "athen", "athina", "thessaloniki", "mykonos", "santorini", "crete", "kreta"]
  },
  {
    canonical: "Switzerland",
    priority: 2,
    terms: ["zurich", "zurich", "zürich", "geneva", "genf", "geneve", "basel", "bern"]
  },
  {
    canonical: "Austria",
    priority: 2,
    terms: ["vienna", "wien", "salzburg", "innsbruck", "graz"]
  },
  {
    canonical: "South Korea",
    priority: 2,
    terms: ["seoul", "busan", "jeju", "incheon"]
  },
  {
    canonical: "Indonesia",
    priority: 2,
    terms: ["bali", "jakarta", "yogyakarta", "lombok"]
  },
  {
    canonical: "Malaysia",
    priority: 2,
    terms: ["kuala lumpur", "kl", "penang", "langkawi"]
  },
  {
    canonical: "Singapore",
    priority: 2,
    terms: ["singapore city"]
  },
  {
    canonical: "Vietnam",
    priority: 2,
    terms: ["hanoi", "ho chi minh", "saigon", "da nang", "hoi an"]
  },
  {
    canonical: "Morocco",
    priority: 2,
    terms: ["marrakech", "marrakesh", "casablanca", "fez", "fes", "rabat", "tangier"]
  },
  {
    canonical: "Egypt",
    priority: 2,
    terms: ["cairo", "kairo", "luxor", "hurghada", "sharm el sheikh", "alexandria"]
  },
  {
    canonical: "Saudi Arabia",
    priority: 2,
    terms: ["riyadh", "jeddah", "mecca", "medina", "mekka"]
  },
  {
    canonical: "Israel",
    priority: 2,
    terms: ["tel aviv", "jerusalem", "haifa", "eilat"]
  },
  {
    canonical: "Jordan",
    priority: 2,
    terms: ["amman", "petra", "aqaba"]
  },
  {
    canonical: "Philippines",
    priority: 2,
    terms: ["manila", "cebu", "boracay", "palawan", "davao"]
  },
  {
    canonical: "New Zealand",
    priority: 2,
    terms: ["auckland", "wellington", "christchurch", "queenstown"]
  },
  {
    canonical: "Argentina",
    priority: 2,
    terms: ["buenos aires"]
  },
  {
    canonical: "Colombia",
    priority: 2,
    terms: ["bogota", "medellin", "cartagena", "cali"]
  },
  {
    canonical: "Peru",
    priority: 2,
    terms: ["lima", "cusco", "machu picchu"]
  },
  {
    canonical: "Kenya",
    priority: 2,
    terms: ["nairobi", "mombasa"]
  },
  {
    canonical: "South Africa",
    priority: 2,
    terms: ["cape town", "kapstadt", "johannesburg", "durban", "pretoria"]
  },
  {
    canonical: "Tanzania",
    priority: 2,
    terms: ["dar es salaam", "zanzibar", "kilimanjaro"]
  },
  {
    canonical: "Iceland",
    priority: 2,
    terms: ["reykjavik", "reykjavik"]
  },
  {
    canonical: "Norway",
    priority: 2,
    terms: ["oslo", "bergen", "tromso", "tromsø"]
  },
  {
    canonical: "Sweden",
    priority: 2,
    terms: ["stockholm", "gothenburg", "goteborg", "göteborg", "malmo", "malmö"]
  },
  {
    canonical: "Denmark",
    priority: 2,
    terms: ["copenhagen", "kopenhagen", "kobenhavn", "københavn", "aarhus"]
  },
  {
    canonical: "Finland",
    priority: 2,
    terms: ["helsinki", "tampere", "turku"]
  },
  {
    canonical: "Poland",
    priority: 2,
    terms: ["warsaw", "warschau", "varsovie", "krakow", "krakau", "gdansk", "wroclaw"]
  },
  {
    canonical: "Czech Republic",
    priority: 2,
    terms: ["prague", "prag", "brno"]
  },
  {
    canonical: "Hungary",
    priority: 2,
    terms: ["budapest"]
  },
  {
    canonical: "Romania",
    priority: 2,
    terms: ["bucharest", "bukarest", "cluj", "brasov"]
  },
  {
    canonical: "Croatia",
    priority: 2,
    terms: ["zagreb", "dubrovnik", "split", "pula"]
  },
  {
    canonical: "Serbia",
    priority: 2,
    terms: ["belgrade", "belgrad"]
  },
  {
    canonical: "Ukraine",
    priority: 2,
    terms: ["kyiv", "kiew", "kiev", "odessa", "lviv"]
  },
  {
    canonical: "Russia",
    priority: 2,
    terms: ["moscow", "moskau", "st petersburg", "saint petersburg"]
  },
  {
    canonical: "Hong Kong",
    priority: 2,
    terms: ["kowloon", "causeway bay"]
  },
  {
    canonical: "Taiwan",
    priority: 2,
    terms: ["taipei"]
  },
  {
    canonical: "Bangladesh",
    priority: 2,
    terms: ["dhaka"]
  },
  {
    canonical: "Pakistan",
    priority: 2,
    terms: ["karachi", "lahore", "islamabad"]
  },
  {
    canonical: "Sri Lanka",
    priority: 2,
    terms: ["colombo", "kandy"]
  },
  {
    canonical: "Nepal",
    priority: 2,
    terms: ["kathmandu"]
  },
  {
    canonical: "Cambodia",
    priority: 2,
    terms: ["phnom penh", "siem reap", "angkor"]
  },
  {
    canonical: "Myanmar",
    priority: 2,
    terms: ["yangon", "mandalay"]
  },
  {
    canonical: "Kazakhstan",
    priority: 2,
    terms: ["almaty", "astana", "nur-sultan"]
  },
  {
    canonical: "Georgia",
    priority: 2,
    terms: ["tbilisi", "tiflis", "batumi"]
  },
  {
    canonical: "Armenia",
    priority: 2,
    terms: ["yerevan", "eriwan"]
  },
  {
    canonical: "Azerbaijan",
    priority: 2,
    terms: ["baku"]
  },
  {
    canonical: "Kuwait",
    priority: 2,
    terms: ["kuwait city"]
  },
  {
    canonical: "Qatar",
    priority: 2,
    terms: ["doha"]
  },
  {
    canonical: "Bahrain",
    priority: 2,
    terms: ["manama"]
  },
  {
    canonical: "Oman",
    priority: 2,
    terms: ["muscat", "maskat"]
  },
  {
    canonical: "Lebanon",
    priority: 2,
    terms: ["beirut", "beyrouth"]
  },
  {
    canonical: "Iraq",
    priority: 2,
    terms: ["baghdad", "erbil"]
  },
  {
    canonical: "Tunisia",
    priority: 2,
    terms: ["tunis", "djerba", "sousse"]
  },
  {
    canonical: "Nigeria",
    priority: 2,
    terms: ["lagos", "abuja"]
  },
  {
    canonical: "Ghana",
    priority: 2,
    terms: ["accra"]
  },
  {
    canonical: "Senegal",
    priority: 2,
    terms: ["dakar"]
  },
  {
    canonical: "Ethiopia",
    priority: 2,
    terms: ["addis ababa", "addis abeba"]
  },
  {
    canonical: "Rwanda",
    priority: 2,
    terms: ["kigali"]
  },
  {
    canonical: "Ivory Coast",
    priority: 2,
    terms: ["abidjan"]
  },
  {
    canonical: "Mozambique",
    priority: 2,
    terms: ["maputo"]
  },
  {
    canonical: "Bolivia",
    priority: 2,
    terms: ["la paz", "santa cruz"]
  },
  {
    canonical: "Chile",
    priority: 2,
    terms: ["santiago"]
  },
  {
    canonical: "Ecuador",
    priority: 2,
    terms: ["quito", "guayaquil"]
  },
  {
    canonical: "Uruguay",
    priority: 2,
    terms: ["montevideo"]
  },
  {
    canonical: "Paraguay",
    priority: 2,
    terms: ["asuncion", "asunción"]
  },
  {
    canonical: "Costa Rica",
    priority: 2,
    terms: ["san jose", "san josé"]
  },
  {
    canonical: "Panama",
    priority: 2,
    terms: ["panama city"]
  },
  {
    canonical: "Guatemala",
    priority: 2,
    terms: ["guatemala city"]
  },
  {
    canonical: "Cuba",
    priority: 2,
    terms: ["havana", "habana"]
  },
  {
    canonical: "Jamaica",
    priority: 2,
    terms: ["kingston", "montego bay"]
  },
  {
    canonical: "Trinidad and Tobago",
    priority: 2,
    terms: ["port of spain"]
  },
];

  window.resolveSearchTerm = function(raw) {
    const normalized = normalize(raw);
    if (normalized.length < 2) return raw;

    const sorted = [...SEARCH_INDEX].sort((a, b) => a.priority - b.priority);

    for (const entry of sorted) {
      if (entry.terms.includes(normalized)) return entry.canonical;
    }

    if (normalized.length >= 3) {
      for (const entry of sorted) {
        for (const term of entry.terms) {
          if (term.startsWith(normalized)) return entry.canonical;
        }
      }
    }

    return raw;
  };
})();